import { useTranslation } from '@utils/i18n/i18n.consumers';

import './admin-hazard-tags.styl';

function AdminHazardTags({
  hazards = [],
}) {
  const { t } = useTranslation();

  return (
    <div className="admin-hazard-tags">
      {hazards.map(hazard => (
        <span key={hazard} className="admin-hazard-tags__tag">
          {t(hazard)}
        </span>
      ))}
    </div>
  );
}

export default AdminHazardTags;